/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { IHosportsCustomSacSendViewProps } from '../../../modules/hosports-custom-sac-send/./hosports-custom-sac-send';
//@ts-ignore
import Parse from 'parse';
//@ts-ignore
import {GeneralAssetUrl} from './../utilities/constants';

interface IState {
  name?:any;
  email?:any;
  phone?:any;
  height?:any;
  width?:any;
  length?:any;
  flang?:any;
  style?:any;
  labor?:any;
  design?:any;
  cost?:any;
  accessories?:any;
  messageSent?:any;
  backgroundImage?:any;
}

/**
 *
 * Parallax Loose Grid component
 * @extends {React.Component<IHosportsVideoBoxViewProps>}
 */
class HosportsCustomSacSend extends React.Component<IHosportsCustomSacSendViewProps,IState> {

  public state: IState;

  constructor (props: IHosportsCustomSacSendViewProps) {
      super(props);
      this.state = {};
  }

  public componentDidMount =() =>{
    if (typeof window !== 'undefined') {
      let localOrder:any = localStorage.getItem("customSacOrder");
      let order:any = JSON.parse(localOrder);
      let height:any = "";
      let width:any = "";
      let length:any = "";
      let flang:any = "";
      let style:any = "";
      let labor:any = "";
      let design:any = "";
      let cost:any = "";
      let accessories:any = "";
      if(order.height){
        height = order.height
      }
      if(order.width){
        width = order.width
      }
      if(order.length){
        length = order.length
      }
      if(order.flang){
        flang = order.flang
      }
      if(order.style){
        style = order.style
      }
      if(order.labor){
        labor = '$'+order.labor
      }
      if(order.design){
        design = '$'+order.design
      }
      if(order.cost){
        cost = '$'+order.cost
      }
      if(order.accessories){
        accessories = order.accessories
      }
      this.setState({
        name:'',
        email:'',
        phone:'',
        height:height,
        width:width,
        length:length,
        flang:flang,
        style:style,
        labor:labor,
        design:design,
        cost:cost,
        accessories:accessories
      })
   }
  }
  public handleNameChange = (e:any) =>{
    var name = e.target.value;
    this.setState({
      name:name
    })
  }
  public handleEmailChange = (e:any) =>{
    var email = e.target.value;
    this.setState({
      email:email
    })
  }
  public handlePhoneChange = (e:any) =>{
    var phone = e.target.value;
    this.setState({
      phone:phone
    })
  }
  public submitForm = () => {
    if(!this.state.name || !this.state.email || !this.state.phone){
      alert('Please Fill Out your contact info')
    }

    else{
      Parse.Cloud.run('customSacForm',
      {
        name: this.state.name,
        email: this.state.email,
        phone:this.state.phone,
        height:this.state.height,
        width:this.state.width,
        length:this.state.length,
        flang:this.state.flang,
        shape:this.state.style,
        labor:this.state.labor,
        design:this.state.design,
        cost:this.state.cost,
        accessories:this.state.accessories,
        website:"fatsac.com"
      }
    ).then((data:any) => {
        this.setState({
          messageSent:true,
          name: "",
          email: "",
          phone: "",
        })
      });
    }
  }

  public render(): JSX.Element {
    const { config } = this.props;
     let backgroundImage:any = config.backgroundImage ? config.backgroundImage.src : "";
      return (
        <div>
          <div className="background-image-fill" style={{backgroundImage:`url(${backgroundImage})`, height:'100vh',display:'flex'}}>
            <div className="small-max-width-container white-background medium-padding shadow" style={{"margin":"auto"}}>
              {!this.state.messageSent &&
                <div>
                  <h4 className="full-width centered-text">{'Please provide your contact info for a custom quote request'}</h4>
                  <p className="subheading">{'Don\'t forget to add any pumps, hoses, or fittings to your custom sac quote today!'}</p>
                  <p className="form-label subheading">{'Name'}</p>
                  <input type="text" value={this.state.name} onChange={this.handleNameChange} style={{width:'100%', padding:'10px', backgroundColor:'#f9f9f9', border:'0px solid'}} />
                  <p className="form-label subheading">{'Email'}</p>
                  <input type="text" value={this.state.email} onChange={this.handleEmailChange} style={{width:'100%', padding:'10px', backgroundColor:'#f9f9f9', border:'0px solid'}} />
                  <p className="form-label subheading">{'Phone'}</p>
                  <input type="text" value={this.state.phone} onChange={this.handlePhoneChange} style={{width:'100%', padding:'10px', backgroundColor:'#f9f9f9', border:'0px solid'}} />
                  <div className="max-width-container">
                    <div className="row">
                      <div className="small-12 medium-6 tiny-padding">
                        <a className="button grey-background white full-width centered-text" href={'/calculator'}>{'Modify'}</a>
                      </div>
                      <div className="small-12 medium-6 tiny-padding">
                        <div className="button primary-color-background white full-width centered-text" onClick={this.submitForm}>{'Submit'}</div>
                      </div>
                    </div>
                  </div>
                  <div className="centered-text" style={{marginTop:"20px"}}></div>
               </div>
              }
              {this.state.messageSent &&
                <div className="success-container full-width">
                  <div className="success-container-text full-width  centered-text">
                    <img className="success-check" src={GeneralAssetUrl+"checked.png"} style={{margin:'auto', height:100, width:100}} />
                    <h4 className="full-width">{'Your Message Has Been Sent'}</h4>
                  </div>
                </div>
              }
            </div>
          </div>
  		</div>
    );
  }
}

export default HosportsCustomSacSend;
